import React, { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import type { ExtraConfig } from '@gov-nx/core/app/extra-config/context.types';
import { getPagePartSlug } from '@gov-nx/module/page/definitions/PageMap';
import { MySubmissionTabs } from '@gov-nx/module/page/moje-podani/seznam/submissionTabs';
import AuthorizedRoute from '../../routes/AuthorizedRoute';

const MySubmissionsLayoutPage = lazy(() =>
	import('./MySubmissionsLayoutPage').then(({ MySubmissionsLayoutPage }) => ({
		default: MySubmissionsLayoutPage,
	}))
);
const SubmissionDetailPage = lazy(() =>
	import('./SubmissionDetailPage').then(({ SubmissionDetailPage }) => ({
		default: SubmissionDetailPage,
	}))
);

const AuthorizationDetailPage = lazy(() =>
	import('./AuthorizationDetailPage').then(({ AuthorizationDetailPage }) => ({
		default: AuthorizationDetailPage,
	}))
);

export const getSubmissionsRoutes = (
	extraConfig: ExtraConfig['submissionsRoutes']
): RouteObject[] => {
	const { podani, osvedceni, autorizace } = extraConfig.routesConfig;
	return [
		{
			path: getPagePartSlug('moje-podani'),
			children: [
				...(podani.isAvailable
					? [
							{
								index: true,
								element: (
									<AuthorizedRoute>
										<MySubmissionsLayoutPage
											selectedTab={MySubmissionTabs.podani}
										/>
									</AuthorizedRoute>
								),
							},
							{
								path: getPagePartSlug('moje-podani.detail'),
								element: (
									<AuthorizedRoute>
										<SubmissionDetailPage />
									</AuthorizedRoute>
								),
							},
						]
					: []),
				...(osvedceni.isAvailable
					? [
							{
								path: getPagePartSlug('moje-podani.osvedceni'),
								element: (
									<AuthorizedRoute>
										<MySubmissionsLayoutPage
											selectedTab={MySubmissionTabs.osvedceni}
										/>
									</AuthorizedRoute>
								),
							},
						]
					: []),

				...(autorizace.isAvailable
					? [
							{
								path: getPagePartSlug('moje-podani.autorizace'),
								element: (
									<AuthorizedRoute>
										<MySubmissionsLayoutPage
											selectedTab={MySubmissionTabs.autorizace}
										/>
									</AuthorizedRoute>
								),
							},
							{
								path: `${getPagePartSlug('moje-podani.autorizace')}/${getPagePartSlug('moje-podani.autorizace.detail')}`,
								element: (
									<AuthorizedRoute>
										<AuthorizationDetailPage />
									</AuthorizedRoute>
								),
							},
						]
					: []),
			],
		},
	];
};
